import { forwardRef } from "react";
import { Link, LinkProps } from "react-router-dom";
import classNames from "classnames";

/** The props used for the {@link NavigationLink} component. */
interface NavigationLinkProps {
  /** Whether to display the link in lowercase stylistically. */
  lower?: boolean;
}

/* A component that represents a navigation link. Forwards its ref to the
 * underlying anchor so it can be used as the immediate child of components
 * that need to attach a ref (e.g. MUI's Tooltip). */
const NavigationLink = forwardRef<HTMLAnchorElement, LinkProps & NavigationLinkProps>(({
  children,
  lower,
  ...props
}, ref) => {
  return (
    <Link ref={ref} className={classNames("nav-link", { lower })} {...props}>
      {children}
    </Link>
  );
});

export default NavigationLink;
export type { NavigationLinkProps };
